import * as actions from "../constants/actionTypes";

const initialState = null;

export default function user(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOGGED_IN:
            newState = action.payload;
            break;
        default: break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/user.js